import { useMemo } from "react";

export default function useMinimapDimensions({
    trueWidth,
    imgDisplayHeight,
    containerSize,
    isMobile,
    shortPos,
    longPos,
    yScale,
    vWidth,
    vShort,
    vLong,
    isMinimapFull,
}) {
    return useMemo(() => {
        const aspectRatio = trueWidth / (imgDisplayHeight || 1);
        const CORNER_MAX_W = isMobile ? 160 : 200;
        const CORNER_MAX_H = isMobile ? 180 : 220;
        const paddingW = 24;
        const paddingH = isMobile ? 200 : 60;
        const maxFullW = containerSize.w > paddingW ? containerSize.w - paddingW : 500;
        const maxFullH = containerSize.h > paddingH ? containerSize.h - paddingH : 600;

        const cornerImageW = CORNER_MAX_W;
        const cornerImageH = CORNER_MAX_W / aspectRatio;
        const cornerContainerW = CORNER_MAX_W;
        const cornerContainerH = Math.min(CORNER_MAX_H, cornerImageH);

        const expandedSize = Math.min(maxFullW, maxFullH);
        let expandedImageW, expandedImageH;
        if (aspectRatio <= 1) {
            expandedImageW = expandedSize;
            expandedImageH = expandedSize / aspectRatio;
        } else {
            expandedImageH = expandedSize;
            expandedImageW = expandedSize * aspectRatio;
        }

        const minimapContainerW = isMinimapFull ? expandedSize : cornerContainerW;
        const minimapContainerH = isMinimapFull ? expandedSize : cornerContainerH;
        const minimapImageW = isMinimapFull ? expandedImageW : cornerImageW;
        const minimapImageH = isMinimapFull ? expandedImageH : cornerImageH;

        const miniScale = trueWidth > 0 ? minimapImageW / trueWidth : 1;
        const minimapShortW = vWidth * miniScale;
        const minimapShortH = vShort * miniScale;
        const minimapLongW = vWidth * miniScale;
        const minimapLongH = vLong * miniScale;
        const DOT_RADIUS = 12;

        const dotShortX = (shortPos.x + vWidth / 2) * miniScale - DOT_RADIUS;
        const dotShortY = (shortPos.y * yScale * miniScale + minimapShortH / 2) - DOT_RADIUS;
        const dotLongX = (longPos.x + vWidth / 2) * miniScale - DOT_RADIUS;
        const dotLongY = (longPos.y * yScale * miniScale + minimapLongH / 2) - DOT_RADIUS;

        const boundsShort = {
            left: (minimapShortW / 2) - DOT_RADIUS,
            top: (minimapShortH / 2) - DOT_RADIUS,
            right: minimapImageW - (minimapShortW / 2) - DOT_RADIUS,
            bottom: minimapImageH - (minimapShortH / 2) - DOT_RADIUS,
        };
        const boundsLong = {
            left: (minimapLongW / 2) - DOT_RADIUS,
            top: (minimapLongH / 2) - DOT_RADIUS,
            right: minimapImageW - (minimapLongW / 2) - DOT_RADIUS,
            bottom: minimapImageH - (minimapLongH / 2) - DOT_RADIUS,
        };

        return {
            minimapContainerW, minimapContainerH,
            minimapImageW, minimapImageH,
            dotShortX, dotShortY, dotLongX, dotLongY,
            boundsShort, boundsLong,
            miniScale, DOT_RADIUS,
        };
    }, [trueWidth, imgDisplayHeight, containerSize, isMobile, shortPos, longPos, yScale, vWidth, vShort, vLong, isMinimapFull]);
}
